import React, { useMemo, useRef, useState } from "react";
import Icon from "../../../Elements/Icon/Icon.tsx";
import FilesActionGroup from "../../../Reusable/FilesActionGroup/FilesActionGroup.js";
import useMediaQueries from "../../../../hooks/useMediaQueries.js";
import DownloadComponent from "./DownloadComponent.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useMailView } from "../../../../contexts/mailViewContext/mailViewContext.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import bytesToDisplayHelper from "../../../../utils/bytesToDisplayHelper.js";
import CustomPopup from "../../../Pages/Inbox/Popups/CustomPopup.js";
import useOnClickOutside from "../../../../hooks/useOnClickOutside.js";
import { useActionList } from "hooks/useActionList.js";
import useSelfRemovalLink from "hooks/useSelfRemovalLink.tsx";

const SelectionHeader = () => {
  const { getMailMetaData, getFilesData, getMailSecurity } = useMail();
  const { getFilesSelection, setFilesSelection } = useMailView();
  const { getTextByKey } = useContent();
  const { desktopCondition, Desktop } = useMediaQueries();
  const [mobileActions, setMobileActions] = useState(false);

  const actionList = useActionList({
    defaultActionList: ["CollectionModal", "Share", "RemoveFile"],
    security: getMailSecurity(),
  });

  const sumSize = useMemo(
    () =>
      getFilesSelection().reduce(
        (acc, currId) => acc + (getFilesData()[currId]?.Size || 0),
        0
      ),
    [getFilesSelection()]
  );

  const sumSizeMB = bytesToDisplayHelper(sumSize);

  const ref = useRef();
  useOnClickOutside(ref, () => setMobileActions(false));

  const isSelfRemove = useSelfRemovalLink();

  return (
    <div
      className={`selection-header flex-row 
      ${!desktopCondition ? "mobile-selection-header " : ""} `}
    >
      <Desktop>
        <div className="number-of-selected">
          {`${getFilesSelection().length} 
            ${getTextByKey("selectionheader-selected") || ""} (${
            sumSizeMB.size + sumSizeMB.type
          })
            `}
        </div>
        <div className="flex-spacer" />
      </Desktop>
      <div className="flex-row selection-action">
        {desktopCondition ? (
          <>
            {!isSelfRemove ? (
              <>
                <FilesActionGroup
                  actionList={actionList}
                  className="gray-icons"
                />
                <DownloadComponent classNames="download-selected" />
              </>
            ) : null}
            <Icon name="x" gray onClick={() => setFilesSelection([])} />
          </>
        ) : (
          <>
            <Icon name="x" gray onClick={() => setFilesSelection([])} />
            <div className="mobile-selection-download">
              <div className="selected-counter-container">
                <span className="selected-counter">
                  {getFilesSelection().length}
                </span>
                <span> / {getMailMetaData().filesCount}</span>
                <span className="selected-size">
                  ({sumSizeMB.size + sumSizeMB.type})
                </span>
              </div>
            </div>
            <div className="flex-spacer" />
            <DownloadComponent classNames="download-selected" />
            <div ref={ref}>
              <Icon
                name="dots-vertical"
                gray
                onClick={() => {
                  setMobileActions((prev) => !prev);
                }}
              />
            </div>
            <CustomPopup showState={mobileActions} topPosition={70}>
              <FilesActionGroup
                actionList={actionList}
                className="gray-icons"
              />
            </CustomPopup>
          </>
        )}
      </div>
    </div>
  );
};

export default SelectionHeader;
